// actions.js
import { CREATE_USER, CREATE_USER_ERROR, CREATE_USER_SUCCESS, EDIT_USER, EDIT_USER_ERROR, EDIT_USER_SUCCESS, GET_ALL_USERS, GET_ALL_USERS_ERROR, GET_ALL_USERS_SUCCESS, CHANGE_USER_STATUS, CHANGE_USER_STATUS_SUCCESS,CHANGE_USER_STATUS_ERROR, DELETE_USER, DELETE_USER_SUCCESS, DELETE_USER_ERROR } from '../actionTypes'


export const getUsers = (page, rowsPerPage, searchText, columnFilters, sorting,setCount,setData, setIsLoading, dataType) => ({
  type: GET_ALL_USERS,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting,setCount,setData, setIsLoading, dataType },
});

export const getUsersSuccess = (data) => ({
  type: GET_ALL_USERS_SUCCESS,
  payload: data,
});

export const getUsersError = (error) => ({
  type: GET_ALL_USERS_ERROR,
  payload: error,
});


export const createUser = (profileData, roles, toggleModal, refresh, setIsSubmitting) => ({
  type: CREATE_USER,
  payload: { profileData, roles, toggleModal, refresh, setIsSubmitting },
});

export const createUserSuccess = (data) => ({
  type: CREATE_USER_SUCCESS,
  payload: data,
});

export const createUserError = (error) => ({
  type: CREATE_USER_ERROR,
  payload: error,
});

export const editUser = (userId, profileData, roles, toggleModal, refresh, setIsSubmitting) => ({
  type: EDIT_USER,
  payload: {userId, profileData, roles, toggleModal, refresh, setIsSubmitting },
});

export const editUserSuccess = (data) => ({
  type: EDIT_USER_SUCCESS,
  payload: data,
});

export const editUserError = (error) => ({
  type: EDIT_USER_ERROR,
  payload: error,
});

export const changeStatus = (userId, statusData, refresh) => ({
  type: CHANGE_USER_STATUS,
  payload: {userId, statusData, refresh },
});

export const changeStatusSuccess = (data) => ({
  type: CHANGE_USER_STATUS_SUCCESS,
  payload: data,
});

export const changeStatusError = (error) => ({
  type: CHANGE_USER_STATUS_ERROR,
  payload: error,
});

export const deleteUser = (userId, refresh) => ({
  type: DELETE_USER,
  payload: {userId, refresh },
});

export const deleteUserSuccess = (data) => ({
  type: DELETE_USER_SUCCESS,
  payload: data,
});

export const deleteUserError = (error) => ({
  type: DELETE_USER_ERROR,
  payload: error,
});
